module.exports = __webpack_public_path__ + "static/img/promotion-poster.4775cf81.jpg";